import { useEffect } from 'react';
import './App.css';
import AppRouter from './router/AppRouter';
import { Provider } from 'react-redux';
import PageLoader from './core/FullPageLoader/FullPageLoader';
import {store} from './Store'
import { reloadIfNewDeployment } from './_util/deployCheck';
import { APP_VERSION } from './_util/session';

// 20260706200317 → v2026.07.06-2003
const displayVersion =
  APP_VERSION && APP_VERSION.length === 14
    ? `v${APP_VERSION.slice(0, 4)}.${APP_VERSION.slice(4, 6)}.${APP_VERSION.slice(6, 8)}-${APP_VERSION.slice(8, 12)}`
    : `v${APP_VERSION}`;

function App() {
  useEffect(() => {
    reloadIfNewDeployment();
    // Long-lived tabs: re-check whenever the user comes back to the tab
    window.addEventListener('focus', reloadIfNewDeployment);
    return () => window.removeEventListener('focus', reloadIfNewDeployment);
  }, []);

  return (
    <>
      <Provider store={store}>
        <PageLoader />
        <AppRouter />
      </Provider>
      <div
        style={{
          position: 'fixed',
          bottom: 4,
          right: 8,
          fontSize: 10,
          color: '#9e9e9e',
          zIndex: 1300,
          pointerEvents: 'none',
          userSelect: 'none',
        }}
      >
        {displayVersion}
      </div>
    </>
  );
}

export default App;

